import * as React from 'react'
import {useStore} from 'common/useStore'
import styled from 'styled-components/macro'
import {useMapStore} from 'map/useMapStore'
import {ascendColors} from 'common/GlobalStyles'

const AssetListControlDiv = styled.div<{
  assetListOpen: boolean
}>`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  user-select: none; /*prevents highlighting the dropdown items*/
  background: var(--primary);
  padding: 10px 5px;
  border-radius: 20px;
  margin: 10px;
  justify-content: center;
  box-shadow: 2px 4px 8px 1px rgba(0, 0, 0, 0.35);
  cursor: ${props => (props.assetListOpen ? 'default' : 'pointer')};
  /*:hover {
    box-shadow: 0px 4px 5px 0px var(--asc-graphite);
  }*/
`

const ItemBadge = styled.div<{fontColor: string}>`
  max-width: 60%;
  min-height: 1em;
  padding: 0.37em 0.5em;
  line-height: 1em;
  text-align: center;
  border-radius: 500rem;
  background-color: var(--secondary);
  color: ${props => props.fontColor};
  font-weight: bold;
  align-self: center;
`

const ItemLabel = styled.div<{fontColor: string}>`
  display: flex;
  font-size: 13px;
  margin-right: 5px;
  color: ${props => props.fontColor};
  font-weight: 600;
`

const AssetListControl = () => {
  const setAssetListOpen = useStore(state => state.setAssetListOpen)
  const setGridOpen = useStore(state => state.setGridOpen)
  const assetListOpen = useStore(state => state.assetListOpen)
  const assetsCount = useMapStore(state => state.gutAssetData.assetCount)
  const totalActiveAssets = useMapStore(state => state.totalActiveAssets)

  const onClick = () => {
    setAssetListOpen(true)
    setGridOpen(false)
    useMapStore.setState({showAssetMarkers: true})
  }

  return (
    <React.Fragment>
      <AssetListControlDiv
        onClick={onClick}
        data-testid="map-assetcount"
        assetListOpen={assetListOpen}
      >
        <ItemLabel fontColor={ascendColors.fontOnPrimary}>ASSETS</ItemLabel>
        <ItemBadge fontColor={ascendColors.fontOnSecondary}>
          {totalActiveAssets > 0 && totalActiveAssets !== assetsCount
            ? `${new Intl.NumberFormat().format(
                totalActiveAssets,
              )} of ${new Intl.NumberFormat().format(assetsCount)}`
            : new Intl.NumberFormat().format(assetsCount)}
        </ItemBadge>
      </AssetListControlDiv>
    </React.Fragment>
  )
}
export default AssetListControl
